// DashboardColorContext.tsx
import { createContext, useContext } from "react";

export const DashboardColorContext = createContext<string>("#337AB7");

export const useDashboardColor = () => useContext(DashboardColorContext);
